// S256 PKCE + state helpers. Pure functions: no storage, no side effects.

const RANDOM_BYTES = 32;

const base64Url = (bytes: Uint8Array): string => {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
};

const randomBase64Url = (): string => base64Url(crypto.getRandomValues(new Uint8Array(RANDOM_BYTES)));

// 32 random bytes -> 43 base64url chars (within RFC 7636's 43-128 range).
export const createVerifier = (): string => randomBase64Url();

export const createChallenge = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64Url(new Uint8Array(digest));
};

// 43 chars, within the backend's accepted [20,120] state length.
export const createState = (): string => randomBase64Url();
